
<template>
  <div>
    <div
      v-show="showVue"
      style="width: 1300px; margin: 0 auto; margin-top: 50px"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 mb-2 font">
          <img
            src="../../static/images/kucun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            结算申请
          </span>
          <span class="ml-5">
            <span
              >查询时间从
              <span class="yanse" style="font-size: 15px">
                {{ searchForm.DateLessThan | chaxunDate }}
              </span>
              到
              <span class="yanse" style="font-size: 15px">
                {{ searchForm.DateMoreThan | chaxunDate1 }}
              </span>
            </span>
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
              margin-right: 6px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <div
          class="mb-2"
          style="
            margin-left: 20px;
            display: flex;
            align-items: center;
            font-size: 15px;
          "
        >
          <span>供应商名称:</span>
          <input
            type="text"
            class="input_form-control ml-2"
            v-model="supplierName"
          />
          <span class="ml-2">备注:</span>
          <input type="text" class="input_form-control ml-2" v-model="Remark" />
          <span class="ml-3 mr-2">查询日期:</span>
          <date3 @changeDate="changeDate1($event)" />
          <span class="ml-3 mr-2">到:</span>
          <date @changeDate="changeDate2($event)" />
          <button
            class="bg-primary button_zi heit ml-4"
            @click="getClerkStoreGoodsQuery()"
          >
            查询
          </button>
        </div>

        <div v-if="showPage">
          <table class="table table-striped table-hover">
            <thead>
              <tr style="white-space: nowrap" class="text-center">
                <th>供应商编号</th>
                <th>供货商名称</th>
                <th>开户行</th>
                <th>账号</th>
                <th>结款类型名称</th>
                <th>结款申请金额</th>
                <th>结款申请状态</th>
                <th>结款申请人</th>
                <th>结款申请时间</th>
                <th>备注</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index">
                <td class="jz_middle">{{ item.supplierNum }}</td>
                <td class="jz_middle">{{ item.supplierName }}</td>
                <td class="jz_middle">
                  {{ item.openingBank }}
                </td>
                <td class="jz_middle">
                  {{ item.account }}
                </td>
                <td class="jz_middle">{{ item.settleTypeName }}</td>
                <td class="jz_middle">{{ item.money }}</td>
                <td class="jz_middle">{{ item.progress }}</td>
                <td class="jz_middle">{{ item.creater }}</td>
                <td class="jz_middle">{{ item.createDate | formatUTC }}</td>
                <td class="jz_middle">{{ item.remark }}</td>
                <td class="jz_middle" style="width: 100px">
                  <button
                    v-if="item.progress == '创建'"
                    @click="nullify(item)"
                    class="btn btn-danger"
                    style="font-size: 12px"
                  >
                    作废
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <v-pagination
              :total="total"
              :current-page="current"
              @pagechange="pagechange"
            ></v-pagination>
          </div>
        </div>

        <div v-else>
          <img
            src="../../static/images/wushuju.jpg"
            style="width: 300px; height: 300px; display: block; margin: 0 auto"
            alt=""
          />
        </div>

        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>

      <div
        v-show="showChuang"
        class="card mb-5"
        style="box-shadow: 10px 10px 5px #888888"
      >
        <div
          class="card-header text-center"
          style="background-color: #3190e8; color: #fff; font-size: 15px"
        >
          创建结款申请
        </div>
        <table class="font table_chuang mt-3 mb-3">
          <tr>
            <td class="text-center">
              <span> 供应商编号: </span>
            </td>
            <td>
              <input
                type="text"
                name="txt_departmentname"
                class="form-control"
                id="txt_departmentname"
                placeholder="供应商编号"
                disabled="disabled"
                v-model="create.SupplierNum"
              />
              <!-- <input type="text" placeholder="供应商编号" class="d-none"> -->
            </td>
            <td class="text-center">
              <!-- <button class="btn btn-primary font_btn" id="btn_add">
                                               查询
                                           </button> -->
              <button
                type="button"
                id="btn_submit"
                @click="change1()"
                class="btn btn-primary font_btn"
                data-dismiss="modal"
              >
                <span
                  class="glyphicon glyphicon-floppy-disk"
                  aria-hidden="true"
                ></span
                >查询
              </button>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <span> 供应商名称: </span>
            </td>
            <td>
              <input
                type="text"
                name="txt_parentdepartment"
                class="form-control"
                id="txt_parentdepartment"
                placeholder="供应商名称"
                disabled="disabled"
                v-model="create.SupplierName"
              />
              <!-- <input type="text" placeholder="药品编号" class="d-none"> -->
            </td>
            <!-- <td class="text-center">
                                            <button class="btn btn-primary font_btn" id="btn_yao">
                                               查询
                                            </button>
                                        </td> -->
          </tr>
          <tr>
            <td class="text-center">
              <span> 账号: </span>
            </td>
            <td>
              <!-- <input type="text"  class="form-control"  placeholder="账号" v-model="create.Account"> -->
              <select
                v-model="create.Account"
                class="form-control"
                @change="getOpeningBank(create.Account)"
              >
                <option value="">请选择</option>
                <option
                  v-for="(item, index) in accountsList"
                  :key="index"
                  :value="item.account"
                  v-text="item.account"
                ></option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <span> 开户行: </span>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                placeholder="请选择开户行"
                v-model="create.OpeningBank"
                disabled="disabled"
              />
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <span> 结款类型ID: </span>
            </td>
            <td>
              <!-- <input type="text" name="txt_statu" class="form-control" id="txt_statu" placeholder="采购数量"> -->
              <select v-model="type" class="form-control">
                <option value="">请选择</option>
                <option
                  v-for="(item, index) in types"
                  :key="index"
                  :value="item.del"
                  v-text="item.del"
                ></option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <span> 结款方式: </span>
            </td>
            <td>
              <!-- <input type="text" name="txt_statu" class="form-control" id="txt_statu" placeholder="采购数量"> -->
              <select v-model="create.ClearingForm" class="form-control">
                <option value="">请选择</option>
                <option key="电汇" value="电汇" v-text="'电汇'"></option>
                <option key="承兑" value="承兑" v-text="'承兑'"></option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <span> 结款金额: </span>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                placeholder="结款金额"
                v-model="create.Money"
              />
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <span> 结款备注: </span>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                placeholder="结款备注"
                v-model="create.Remark"
              />
            </td>
          </tr>
          <tr>
            <td colspan="3" class="text-center">
              <button
                type="button"
                id="btn_submit"
                class="btn btn-primary font_btn"
                data-dismiss="modal"
                @click="createclerksettlementapply()"
                :disabled="isDisable"
              >
                <span
                  class="glyphicon glyphicon-floppy-disk"
                  aria-hidden="true"
                ></span
                >创建
              </button>
              <!-- <button type="button" id="btn_submit" class="btn btn-primary font_btn ml-5" data-dismiss="modal"><span class="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span>取消</button> -->
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 详情内容 -->

    <div>
      <transition name="fade">
        <loading v-show="isLoading"> </loading>
      </transition>
    </div>

    <!-- 弹窗内容 -->

    <div
      class="modal fade"
      id="chaxun"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="width: 1200px; position: relative; top: 50px; left: -150px"
        >
          <div class="modal-header">
            <button
              type="button"
              class="close m-0 p-1"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-header">
                <div class="font">查询条件</div>
              </div>
              <div class="card-body">
                <div class="form-group d-flex">
                  <input
                    type="text"
                    class="form-control w-25"
                    placeholder="请输入供应商名称"
                    v-model="searchForm.SupplierQueryStr"
                    @keydown.enter="searchEnterFun1"
                  />
                  <button
                    class="ml-lg-2 btn btn-primary"
                    @click="clerksettlementsupplierquery()"
                  >
                    搜索
                  </button>
                </div>
                <div v-if="showchaxun">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr style="white-space: nowrap" class="text-center">
                        <th>供应商编号</th>
                        <th>供应商名称</th>
                        <th>供应商余额</th>
                        <th>最早欠款日期</th>
                        <th>是否限制办款</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in supplierList" :key="index">
                        <td class="jz_middle">{{ item.supplierNum }}</td>
                        <td class="jz_middle">{{ item.supplierName }}</td>
                        <td class="jz_middle">{{ item.balance }}</td>
                        <td class="jz_middle">{{ item.date | formatUTC }}</td>
                        <td class="jz_middle">{{ item.isLimit | status }}</td>
                        <td v-if="item.isLimit == 0" class="jz_middle">
                          <button
                            class="btn btn-success"
                            style="font-size: 8px"
                            @click="getCode1(index)"
                          >
                            选择
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 分页 -->
                  <div>
                    <v-pagination
                      :total="total1"
                      :current-page="current1"
                      @pagechange="pagechange1"
                    ></v-pagination>
                  </div>
                </div>
                <div v-if="showImage">
                  <img
                    src="../../static/images/wushuju.jpg"
                    style="
                      width: 300px;
                      height: 300px;
                      display: block;
                      margin: 0 auto;
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <span aria-hidden="true"></span>关闭
            </button>
            <!-- <button type="button" class="btn btn-primary" data-dismiss="modal" @click="getCode()"><span aria-hidden="true"></span>确定</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import date from "../components/Date.vue";
import date3 from "../components/Date3.vue";
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";
import { async } from "q";
export default {
  name: "SaleQuery",
  data() {
    return {
      searchForm: {
        supplierNum: "",
        DateMoreThan: "",
        DateLessThan: "",
        DateLessThan1: "",
        DateMoreThan1: "",
        SupplierQueryStr: "",
      }, //搜索内容
      isLoading: false,
      tableData: [],
      showPage: true,
      totalLimitMoney: "",

      total: 1, // 记录总条数
      display: 20, // 每页显示条数
      current: 1, // 当前的页数

      total1: 1, // 记录总条数
      display1: 20, // 每页显示条数
      current1: 1, // 当前的页数

      supplierName: "",

      Remark: "",

      create: {
        SupplierNum: "",
        SupplierName: "",
        OpeningBank: "",
        Account: "",
        SettleTypeID: "0",
        Money: "",
        Remark: "",
        ClearingForm: "",
      },

      supplierList: [],
      accountsList: [],

      showVue: false,

      type: "",
      types: [{ del: "货款" }],

      showChuang: false,

      showchaxun: false,
      showImage: false,

      isDisable: false,
    };
  },
  components: {
    vPagination,
    Loading,
    date,
    date3,
  },
  computed: {},
  filters: {
    //过滤器时间转换
    //时间转换
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },

    status: function (status) {
      if (status == 0) {
        return "不限制";
      } else if (status == 1) {
        return "限制";
      }
    },
    chaxunDate(date) {
      let change_date =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 9);
      return change_date + " 00:00:00";
    },
    chaxunDate1(date) {
      let time_change =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 9);
      let year = new Date(
        new Date(time_change).getTime() - 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(
          new Date(time_change).getTime() - 24 * 60 * 60 * 1000
        ).getMonth() + 1;

      let time_date = new Date(
        new Date(time_change).getTime() - 24 * 60 * 60 * 1000
      ).getDate();

      let time;
      if (month < 10) {
        if (time_date < 10)
          time = year + "-" + "0" + month + "-" + "0" + time_date;
        else {
          time = year + "-" + "0" + month + "-" + time_date;
        }
      } else {
        if (time_date < 10) {
          time = year + "-" + month + "-" + "0" + time_date;
        } else {
          time = year + "-" + month + "-" + time_date;
        }
      }

      let change_date = time;
      return change_date + " 23:59:59";
    },
  },

  methods: {
    nullify(item) {
      this.$prompt("请输入作废原因", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,}$/,
        inputErrorMessage: "作废原因不能为空",
      }).then(async ({ value }) => {
        let params = {
          Remark: value,
          id: item.id,
        };
        const { data: res } = await this.$http.post("Dls/getFun", {
          action: "CreateclerksettlementClose",
          obj: JSON.stringify(params),
        });
        if (res.data.isSucceed) {
          this.$message({
            type: "success",
            message: "作废成功",
          });
          this.getClerkStoreGoodsQuery();
        } else {
          this.$message({
            type: "danger",
            message: res.message,
          });
        }
      });
    },
    getOpeningBank(account) {
      const that = this;
      if (account == "") {
        this.create.OpeningBank = "";
      }
      that.accountsList.forEach(function (item, index) {
        if (item.account == account) {
          that.create.OpeningBank = that.accountsList[index].bankName;
        }
      });
    },

    getCode1(index) {
      this.create.OpeningBank = "";
      this.create.Account = "";
      $("#chaxun").modal("hide");
      this.create.SupplierNum = this.supplierList[index].supplierNum;
      this.create.SupplierName = this.supplierList[index].supplierName;
      this.accountsList = this.supplierList[index].accounts;
      // this.create.OpeningBank = this.accountsList[0].bankName;
      // this.create.Account = this.accountsList[0].account;
    },

    searchEnterFun1(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.clerksettlementsupplierquery();
      }
    },

    change1() {
      $("#myModalLabel").text("查询");
      $("#chaxun").modal();
    },
    //创建结款申请

    createclerksettlementapply: async function () {
      // this.isLoading=true;
      const that = this;
      that.isDisable = true;
      if (
        that.create.SupplierNum == "" ||
        that.create.SupplierName == "" ||
        that.create.OpeningBank == "" ||
        that.create.Account == "" ||
        that.create.SettleTypeID == "" ||
        that.create.Money == "" ||
        that.create.Remark == "" ||
        that.create.ClearingForm == ""
      ) {
        alert("创建内容填写不完整,请填写完整信息");
        that.isDisable = false;
      } else if (that.create.Money <= 0) {
        alert("输入金额必须大于零");
        that.isDisable = false;
      } else {
        console.log(that.type == "货款");
        if (that.type == "货款") {
          that.create.SettleTypeID = 1;
        }
        console.log(that.create.SettleTypeID);
        const { data: res } = await that.$http.post("Dls/getFun", {
          action: "Createclerksettlementapply",
          obj: JSON.stringify({
            SupplierNum: that.create.SupplierNum,
            SupplierName: that.create.SupplierName,
            OpeningBank: that.create.OpeningBank,
            Account: that.create.Account,
            SettleTypeID: that.create.SettleTypeID,
            Money: that.create.Money,
            Remark: that.create.Remark,
            ClearingForm: that.create.ClearingForm,
          }),
        });
        if (res.data.isSucceed) {
          alert(res.data.msg);
          that.isDisable = false;
          that.create.SupplierNum = "";
          that.create.SupplierName = "";
          that.create.OpeningBank = "";
          that.create.Account = "";
          that.create.SettleTypeID = "";
          that.create.Money = "";
          that.create.Remark = "";
          that.create.ClearingForm = "";
          that.getClerkStoreGoodsQuery();
        } else {
          alert(res.data.msg);
          that.isDisable = false;
        }
      }
    },

    //供应商账户查询
    clerksettlementsupplierquery: async function (PageIndex) {
      // this.isLoading=true;
      const that = this;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "Clerksettlementsupplierquery",
        obj: JSON.stringify({
          PageIndex,

          SupplierQueryStr: that.searchForm.SupplierQueryStr.trim(),
        }),
      });
      console.log(res);
      if (res.isok) {
        const obj = res.data;
        this.supplierList = obj.rows;
        if (this.supplierList.length > 0) {
          this.showchaxun = true;
          this.showImage = false;
        } else {
          this.showchaxun = false;
          this.showImage = true;
        }
        this.total1 = obj.record;
      }
    },

    pagechange: function (currentPage) {
      this.getClerkStoreGoodsQuery(currentPage);
    },
    pagechange1: function (currentPage) {
      this.clerksettlementsupplierquery(currentPage);
    },

    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getDay1(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      // console.log(tYear + tMonth +tDate)
      return tYear + "" + tMonth + "" + tDate;
    },

    //动态绑定时间
    changeDate1: function (date) {
      this.searchForm.DateLessThan = date.replace(/\-/g, "");
      this.searchForm.DateLessThan1 = date;
    },
    changeDate2: function (date) {
      let year = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000).getMonth() + 1;

      let time_date = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getDate();
      // console.log(time_date)
      let time;
      if (month < 10) {
        if (time_date < 10) time = "" + year + "0" + month + "0" + time_date;
        else {
          time = "" + year + "0" + month + time_date;
        }
      } else {
        if (time_date < 10) {
          time = "" + year + month + "0" + time_date;
        } else {
          time = "" + year + month + time_date;
        }
      }

      this.searchForm.DateMoreThan = time;
      // console.log(time)
      this.searchForm.DateMoreThan1 = date;
    },

    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },

    getClerkStoreGoodsQuery: async function (PageIndex) {
      this.isLoading = true;
      const that = this;
      let threeMonth = that.getDay(-3 * 30);

      let threeMonthTime = new Date(threeMonth).getTime();

      let today = that.getDay(0);
      let todayTime = new Date(today).getTime();

      let select = that.searchForm.DateLessThan1;

      let select1 = that.searchForm.DateMoreThan1;
      let seTime = new Date(select).getTime();

      let seTime2 = new Date(select1).getTime();

      let ces = that.searchForm.DateLessThan;
      let a = ces.slice(0, 4) + "-" + ces.slice(4, 6) + "-" + ces.slice(6, 9);
      // console.log(a)
      let ces1 = that.searchForm.DateMoreThan;
      let b =
        ces1.slice(0, 4) + "-" + ces1.slice(4, 6) + "-" + ces1.slice(6, 9);
      // console.log(b)
      let cesTime = new Date(a).getTime();
      // console.log(cesTime)
      let cesTime2 = new Date(b).getTime();
      // console.log(cesTime2)
      if (cesTime >= cesTime2) {
        alert("开始日期要小于结束日期");
      } else {
        if (
          threeMonthTime <= seTime &&
          seTime <= todayTime &&
          threeMonthTime <= seTime2 &&
          seTime2 <= todayTime
        ) {
          const { data: res } = await this.$http.post("Dls/getFun", {
            action: "Clerksettlementapplyquery",
            obj: JSON.stringify({
              PageIndex,
              SupplierName: that.supplierName,
              DateMoreThan: that.searchForm.DateLessThan,
              DateLessThan: that.searchForm.DateMoreThan,
              Remark: that.Remark,
            }),
          });
          // console.log(res)
          if (res.isok) {
            this.showVue = true;
            const obj = res.data;
            this.tableData = obj.rows;
            this.total = obj.record;
            this.showChuang = true;
            // this.total = obj.pcount
            if (this.tableData.length > 0) {
              this.showPage = true;
            } else {
              this.showPage = false;
              // alert("暂无数据！")
            }
            this.isLoading = false;
          }
        } else {
          alert("请选择三个月以内的时间进行查询,查询日期不大于当天");
        }
      }
    },
  },
  mounted() {},
  created() {
    this.searchForm.DateMoreThan = this.getDay1(1);
    this.searchForm.DateLessThan = this.getDay1(-7);
    this.searchForm.DateLessThan1 = this.getDay(-8);
    this.searchForm.DateMoreThan1 = this.getDay(0);
    this.getClerkStoreGoodsQuery();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.heit {
  height: 1.5rem;
}
.span_close:hover {
  color: #3190e8;
}

.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.jz_middle {
  vertical-align: middle;
  text-align: center;
}
.input_form-control {
  /* // display: block;  */
  width: 15%;
  height: 24px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input_form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
  opacity: 1;
}
.table_chuang {
  width: 1000px;
  height: 400px;
  margin: 0 auto;
}
.yanse {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/BalanceDue.vue